<template>
  <div class="mt20 p20 tc reviews">
    <div class="pega-text-count-area real-intentions clearfix">
      <text-count
        v-if="textCountMode"
        data-test="text-count"
        name="「社員からの評判」は企業様管理画面でのみ追加・修正が可能です。営業担当者・制作担当者側では編集できません。"
      />
    </div>
    <img
      class="mb10 reviews-img clearfix"
      :src="`${userOfferImageUrlForPc}/reviews.png`"
      alt="reviews"
      data-test="real-intention-img"
    >
    <h3 class="fs15 fwB">
      社員からの評判・口コミをチェック！
    </h3>
    <div
      v-for="(realIntention, i) in realIntentions"
      :key="`real-intention-${i}`"
      class="mt20"
    >
      <job-preview-right-column
        :text-count-mode="textCountMode"
        :highlight-mode="highlightMode"
        comment-class="real-intention"
        :comment-highlights="getAnyCommentHighlights(targetIdMap.realIntention.prefix, i)"
        v-on="$listeners"
      />
      <img
        :src="`${userOfferImageUrlForPc}/icn_circle.png`"
        class="review-li-dot"
      >
      <div class="tl fs13 pl20 pr5 review-inner two-line">
        <p>
          <span
            :id="`${targetIdMap.realIntention.answer}-${i}`"
            :data-test="`answer-${i}`"
            v-text="realIntention.answer1"
          />
        </p>
      </div>
      <p
        :id="`${targetIdMap.realIntention.genderAndCareer}-${i}`"
        class="realintention-right mt5 clearfix"
        :data-test="`gender-and-career-${i}`"
        v-text="`(${realIntention.gender.name}/${realIntention.career})`"
      />
    </div>
    <p class="reviews-link btn-style-02 mt20">
      <a
        target="_blank"
        :style="`background: url(${userCommonImageUrlForPc}/icn_arrow_05.png) no-repeat 8px center;`"
        data-test="button"
      >
        <span>{{ companyName }}の社員からの評判・口コミをすべて見る</span>
      </a>
    </p>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import TextCount from '@/components/atoms/TextCount'
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'

export default {
  components: {
    TextCount,
    JobPreviewRightColumn
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight],
  props: {
    companyName: {
      type: String,
      required: true
    },
    realIntentions: {
      type: Array,
      default: () => []
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      required: true
    }
  }
}
</script>
